import { html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map';
import { TeComponent } from './common/te-component';
import { theme } from './common/theme';

/** Linear Loader Component */
@customElement('te-linear-loader')
export class TeLinearLoader extends TeComponent {
  static styles = [
    ...TeComponent.styles,
    css`
      .linear-loader-container {
        background: ${theme.colors.shade3};
        margin: 0 auto;
      }

      .determinate-linear-loader {
        width: 1%;
        height: 4px;
        background: ${theme.colors.primary.v0};
        border-top-right-radius: 2px;
        border-bottom-right-radius: 2px;
        animation: determinate linear infinite;
      }

      @keyframes determinate {
        0% {
          width: 0%;
        }

        100% {
          width: 100%;
        }
      }

      .indeterminate-linear-loader,
      .indeterminate-linear-loader2 {
        width: 100%;
        height: 4px;
        border-top-right-radius: 2px;
        border-bottom-right-radius: 2px;
      }

      .indeterminate-linear-loader {
        background: ${theme.colors.primary.v0};
        animation: indeterminate 4s ease-in-out infinite;
      }

      .indeterminate-linear-loader2 {
        background: ${theme.colors.shade3};
        animation: indeterminate2 4s ease-in-out infinite;
        z-index: 100;
      }

      @keyframes indeterminate {
        0% {
          width: 10%;
        }

        25% {
          width: 100%;
        }

        50% {
          width: 100%;
        }

        75% {
          width: 100%;
        }

        100% {
          width: 10%;
        }
      }

      @keyframes indeterminate2 {
        0% {
          width: 0%;
        }

        25% {
          width: 0%;
        }

        50% {
          width: 90%;
        }

        75% {
          width: 0%;
        }

        100% {
          width: 0%;
        }
      }
    `,
  ];
  /** Relative / Exact width for loader */
  @property({ type: String }) width = '100%';
  /** Progress value between 0 and 100 */
  @property({ type: Number }) progress?: number;

  getHighlightStyle() {
    return {
      width: this.progress + '%',
    };
  }

  getLoaderSize() {
    return {
      width: this.width,
    };
  }

  render() {
    const isDeterminate = this.progress !== undefined;
    if (isDeterminate) {
      return html`
        <div class="linear-loader-container" style=${styleMap(this.getLoaderSize())}>
          <div class="determinate-linear-loader" style=${styleMap(this.getHighlightStyle())}></div>
        </div>
      `;
    }

    return html`
      <div class="linear-loader-container" style=${styleMap(this.getLoaderSize())}>
        <div class="indeterminate-linear-loader">
          <div class="indeterminate-linear-loader2"></div>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'te-linear-loader': TeLinearLoader;
  }
}
